export default {
  name: 'marking--conformityCertificate',
  apiService: 'shoes',
  apiPath: '/admin/conformity_certificate',

  enums: {
    certType: ['CONFORMITY_CERTIFICATE', 'CONFORMITY_DECLARATION'],
  }
};